import React from "react";
import { Select } from "antd";
// import "antd/dist/antd.css";
// import "../antdstyle.css";

const { Option } = Select;

const SelectCustomLable = (props) => {
  const {
    value,
    onChange,
    options,
    showSearch,
    placeholder,
    tag = "name",
    tag2,
    disabled,
    allowClear,
    showArrow = true,
    className,
  } = props;
  return (
    <div id="selectCustom" className={className}>
      <Select
        // {...props}
        showSearch={showSearch}
        showarrow={showArrow.toString()}
        style={{ width: "100%" }}
        placeholder={placeholder}
        value={value && value !== "" && value}
        onChange={onChange}
        optionFilterProp="children"
        filterOption={(input, option) => {
          const text = option.children || "";
          return String(text).toLowerCase().includes(input.toLowerCase());
        }}
        filterSort={(optionA, optionB) => {
          const textA = optionA?.children || "";
          const textB = optionB?.children || "";
          return String(textA).toLowerCase().localeCompare(String(textB).toLowerCase());
        }}
        disabled={disabled}
        allowClear={allowClear}
      >
        {options.map((item, key) => {
          return (
            <Option key={item._id || key} value={item._id} className="text-capitalize">
              {tag2 ? item[tag] + " (" + item[tag2] + ")" : item[tag]}
            </Option>
          );
        })}
      </Select>
    </div>
  );
};

export default SelectCustomLable;
